import create, { SetState } from 'zustand';
import { INotification } from './Notifications';

export interface INotificationsContext {
  notifications?: INotification[];
  nextNotificationId?: number;
  add?(item: INotification): void;
  remove?(notificationId: string): void;
  removeAll?(): void;
}

export const [useNotificationsContext] = create<INotificationsContext>((set: SetState<INotificationsContext>) => ({
  notifications: [],
  nextNotificationId: 0,
  add: (item: INotification) =>
    set(state => {
      item.notificationId = state.nextNotificationId.toString();
      return {
        notifications: state.notifications.concat([item]),
        nextNotificationId: state.nextNotificationId + 1,
      };
    }),
  remove: (notificationId: string) =>
    set(state => {
      return {
        notifications: state.notifications.filter(entry => entry.notificationId !== notificationId),
      };
    }),
  removeAll: () =>
    set(() => {
      return {
        notifications: [],
      };
    }),
}));
